import { render, staticRenderFns } from "./AlgorithmDivision.vue?vue&type=template&id=671a6388&"
import script from "./AlgorithmDivision.vue?vue&type=script&lang=js&"
export * from "./AlgorithmDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports